import Joi from 'joi';

import { AppSubjectEnum } from '../../../../shared/modules/authz/enums/app-subject.enum';
import { commissionTierItemSchema } from '../../../commission-tier-items/validators/schemas/commission-tier-item.schema';
import { createPoliciesAssignSchema } from '../../../policies/validators/schemas/policies-assign.schema';

/**
 * Schema for existing agent category record validation.
 */
export const updateAgentCategorySchema = () =>
  Joi.object({
    id: Joi.alternatives()
      .conditional(Joi.any().valid(null), {
        then: Joi.invalid(null).messages({
          'any.invalid': 'validations|agent-category-id|cannot-be-null',
        }),
        otherwise: Joi.number().required().messages({
          'any.required': 'validations|agent-category-id|required',
          'number.base': 'validations|agent-category-id|must-be-number',
        }),
      })
      .prefs({ abortEarly: true }),

    name: Joi.alternatives()
      .conditional(Joi.any().valid(null), {
        then: Joi.invalid(null).messages({
          'any.invalid': 'validations|agent-category-name|cannot-be-null',
        }),
        otherwise: Joi.string().required().messages({
          'any.required': 'validations|agent-category-name|required',
          'string.base': 'validations|agent-category-name|must-be-string',
          'string.empty': 'validations|agent-category-name|cannot-be-empty',
        }),
      })
      .prefs({ abortEarly: true }),

    description: Joi.string().allow(null, '').messages({
      'string.base': 'validations|agent-category-description|must-be-string',
    }),

    notes: Joi.string().allow(null, '').messages({
      'string.base': 'validations|agent-category-notes|must-be-string',
    }),

    commissionTierItems: Joi.array()
      .items(commissionTierItemSchema())
      .allow(null),

    policies: createPoliciesAssignSchema(AppSubjectEnum.AGENT_CATEGORY),

    files: Joi.any().allow(null),
  })
    // Ignore extra fields
    .unknown();
